import React, { useState } from 'react';
import { Accordion } from './Accordion';
const bonuses = [{
  icon: '🎯',
  title: 'BONO 01 — Guía de Digitación Imprimible',
  value: '$8.000',
  quote: 'Para pegar en el aula, sin depender de buscarla cada vez.',
  desc: 'Tabla visual completa de digitación de flauta dulce, lista para imprimir en cartel o repartir a los alumnos.',
  image: 'https://images.unsplash.com/photo-1580582932707-520aed937b7b?auto=format&fit=crop&q=80&w=600'
}, {
  icon: '📅',
  title: 'BONO 02 — Planificador Anual de Clases',
  value: '$9.000',
  quote: 'Un ciclo lectivo entero organizado en 3 trimestres.',
  desc: 'Para llegar a marzo con el año ya planificado, sin armar todo de cero cada vez.',
  image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?auto=format&fit=crop&q=80&w=600'
}, {
  icon: '🖼️',
  title: 'BONO 03 — Cartelería de Notas para el Aula',
  value: '$7.000',
  quote: 'Carteles imprimibles para decorar y enseñar al mismo tiempo.',
  desc: 'Para que los alumnos tengan siempre a la vista la nota, su ubicación en el pentagrama y su digitación.',
  image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&q=80&w=600'
}, {
  icon: '📝',
  title: 'BONO 04 — Rúbrica de Evaluación por Trimestre',
  value: '$8.000',
  quote: 'Modelos de evaluación listos para cada ciclo.',
  desc: 'Para evaluar postura, digitación, ritmo y participación sin inventar la rúbrica cada trimestre.',
  image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=600'
}];
export function Bonuses() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return <section className="bg-turquoise text-white py-12" data-id="element-13">
      <div className="max-w-md mx-auto px-4" data-id="element-14">
        <h2 className="text-[28px] font-extrabold text-center mb-2" data-id="element-15">
          4 bonos incluidos. Gratis. Siempre.
        </h2>
        <p className="text-center font-medium mb-8" data-id="element-16">
          Valor total:{' '}
          <span className="line-through opacity-70" data-id="element-17">$32.000 ARS</span> → $0 con
          tu sistema.
        </p>

        <div className="space-y-3" data-id="element-18">
          {bonuses.map((bono, idx) => <Accordion key={idx} isOpen={openIndex === idx} onToggle={() => setOpenIndex(openIndex === idx ? -1 : idx)} icon={bono.icon} title={<div className="flex flex-col" data-id="element-20">
                  <span className="text-[15px]" data-id="element-21">{bono.title}</span>
                  <span className="text-sm font-normal mt-1" data-id="element-22">
                    <span className="line-through opacity-70 mr-2" data-id="element-23">
                      {bono.value}
                    </span>
                    <span className="font-bold text-navy" data-id="element-24">GRATIS</span>
                  </span>
                </div>} className="bg-white/10 border border-white/20 backdrop-blur-sm" headerClassName="hover:bg-white/20" data-id="element-19">
              <div className="pt-2" data-id="element-25">
                <p className="italic text-white/90 text-sm mb-3 font-medium" data-id="element-26">
                  "{bono.quote}"
                </p>
                <p className="text-sm text-white/80 mb-4" data-id="element-27">
                  <strong className="text-white" data-id="element-28">Para qué sirve:</strong>{' '}
                  {bono.desc}
                </p>
                <div className="rounded-xl overflow-hidden h-40 w-full relative" data-id="element-29">
                  <img src={bono.image} alt={bono.title} className="w-full h-full object-cover" data-id="element-30" />
                </div>
              </div>
            </Accordion>)}
        </div>
      </div>
    </section>;
}